<template>
    <div class="modal fade" id="cityDeliveryModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div :class="{ loader: !isShowSppiner }" style="position:absolute;background-color:#80808033;top:0;bottom:0;left:0;right:0;z-index:9999;width:100%;height:100%">
                <img style="position:absolute;top:43%;left:43%;z-index:100" src="/assets/img/loader/loader.svg" />
            </div>
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">ارسال برون شهری</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="container">
                        <div><span class="title">  انتخاب شرکت های حامل  </span></div>
                        <div class="row div-logo-item">

                            <div class="col-sm-4" style="text-align:center" v-for="(carrier,index) in  carriers">
                                <div class="content-img-radio">
                                    <img :src="carrier.IconPath" />
                                    <div class="radio">
                                        <input @change="changeCarrier" type="radio" name="radio2" :id="'radio2_' + index" v-model="selectedCarrierId" :value="carrier.Id">
                                        <label :for="'radio2_' + index">
                                            <span class="carrierName">{{carrier.Name}}</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="btn-div col-12">
                            <div class="btn-estelam-main">
                                <input v-if="selectedCarrierId != 0" @click="getFee" class="btn btn-info btn-estelam" type="button" value="استعلام قیمت" />
                                <div v-if="isInquiry" class="div-loader"><img src="/assets/img/loader/loader.svg" /></div>
                            </div>
                        </div>
                        <div class="col-12 price-all" v-if="isdeliveryFeeCalculated">
                            <div v-if="deliveryFee != null">
                                <span class="title">قیمت ارسال  : </span>
                                <span>{{ deliveryFee | formatNumber  }} تومان</span>
                            </div>
                            <br />
                            <div class="title-message">

                                <span class="title"> <span class="wiki-sign"></span> توجه : </span>
                            </div>
                            <div>
                                <span :class="[(deliveryFee != null) ? 'okStatusMessage' : 'notOkStatusMessage']">{{ deliveryStatusMessage }}  </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="btn-main">
                    <button type="button" class="btn btn-reject" data-dismiss="modal">انصراف</button>
                    <button @click="sendToServer" v-if="isdeliveryFeeCalculated && isValidSelectedCustomerAddressId" type="button" class="btn btn-save">ثبت</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { httpPromise } from "../../module/httpUtility";
    import { getCart } from "../../module/cart";
import { setTimeout } from "timers";
    export default {
        data() {
            return {
                isdeliveryFeeCalculated: false , 
                selectedCarrierId: 0,
                deliveryFee: 0,
                deliveryStatusMessage: '',
                isValidSelectedCustomerAddressId: false,
                isShowSppiner: false,
                isInquiry:false
            }
        },
        props: {
            carriers: {
                type: Array,
                required: true,
            },
            customerAddressId: 0,
        },
        methods: {
            changeCarrier() {
                this.isdeliveryFeeCalculated = false;
                this.isValidSelectedCustomerAddressId = false;
            },
            getFee() {
                this.isInquiry = true;
                var data = {
                    HashCartId: localStorage.getItem('CartHashId'),
                    CarrierId: this.selectedCarrierId,
                    CustomerAddressId: this.customerAddressId, 
                   
                };
                httpPromise(this, '/v1/Orders/CartAddress/GetDeliveryFee', 'get', data,
                    response => {
                        toastr.remove();
                        this.isdeliveryFeeCalculated = true;
                        this.deliveryFee = response.data.Value.DeliveryFee;
                        this.deliveryStatusMessage = response.data.Message;
                        this.isValidSelectedCustomerAddressId = true;
                        this.isInquiry = false;
                    },
                    response => {
                        if (response.status == 400) {
                            this.isdeliveryFeeCalculated = true;
                            this.deliveryFee = response.data.Value.DeliveryFee;
                            this.deliveryStatusMessage = response.data.Message;
                            this.isValidSelectedCustomerAddressId = false;
                            this.isInquiry = false;
                        }
                    });
            }, 
            sendToServer() {
                this.isShowSppiner = true;
                if (this.selectedCarrierId == 0) {
                    toastr.remove();
                    toastr.error('شرکت حامل را انتخاب کنید');
                    return;
                }
                var data = {
                    HashCartId: localStorage.getItem('CartHashId'),
                    CarrierId: this.selectedCarrierId,
                    CustomerAddressId: this.customerAddressId
                }
                httpPromise(this, '/v1/Orders/CartAddress/Apply', 'post', JSON.stringify(data),
                    response => {
                        $(function () {
                            $('#cityDeliveryModal').modal('hide');
                        });
                        toastr.remove();
                        toastr.success(response.data.Message);
                        getCart(this, '');
                        setTimeout(() => this.$router.push('/invoice'), 1000);
                        this.isShowSppiner = false;
                    },
                    response => {
                        toastr.remove();
                        toastr.error(response.data.Message);
                        this.isShowSppiner = false;
                    });
            }, 
        },
    }
</script>

<style scoped>
    .div-loader {
        position: absolute;
        width:102%;
        height:100%;
        top: 0;
        left: -1px;
        background-color: #ddd;
        padding-top: 6px;
        text-align:center
    }
        .div-loader img {
            width: 40px;
        }
        .btn-estelam-main {
            position: relative;
        }
    .modal-content {
        border-radius: unset;
    }

    .modal-content {
        border-radius: 8px;
    }
    .wiki-sign {
        cursor: pointer;
        position: unset;
        margin-right: 0px;
        width: unset;
        height: unset;
        display: unset;
        margin-top: unset;
        vertical-align: middle;
    }
        .wiki-sign::after {
            content: "\ea04";
            font-family: 'Nucleo Outline';
            color: #ababab;
            font-size: 18px;
            line-height: 1.048;
            position: unset;
            top: 50%;
            -webkit-transform: translateY(-50%);
            transform: translateY(-50%);
        }
    .title-message {
        text-align: right;
        margin-bottom: 10px;
    }
    .title {
        margin-left: 10px;
    }
    .carrierName {
        font-weight: bold;
        font-size: 15px;
        color: #666
    }
    .okStatusMessage {
        font-size: 12px;
        padding: 10px 20px 10px 20px;
        background-color: #95db95;
        color: #fff;
        font-weight: bold;
        width: 100%;
        display: block;
    }
    .notOkStatusMessage {
        font-size: 12px;
        padding: 10px 20px 10px 20px;
        background-color: #cc5e5e;
        color: #fff;
        font-weight: bold;
        display:block;
    }
    .radio label::before {
        right: 15px;
    }
    .radio input[type="radio"]:checked + label::after {
        right: 18px
    }
    .radio label::before,.radio label::after {
        right: 15px;

    }
    .content-img-radio img {
        width: 100px;
        height: 100px;
        border: 1px solid #ddd;
        border-radius: 5px;
        overflow: hidden;
        margin-bottom:8px;
        padding:5px;
    }
         .modal-content .modal-header {
            background-color: #aec7f4;
        }
    .modal-content .modal-header{
        background-color: #aec7f4;
    }

    .modal-content .modal-header {
        border-bottom: none;
        padding-top: 8px;
        padding-right: 24px;
        padding-bottom: 13px;
        padding-left: 24px;
    }
    .modal h5 {
        font-size: 18px;
        font-weight: bold;
        color:#fff;
    }
    .btn-estelam {
        width: 100%;
        font-size: 15px;
        font-weight: bold;
    }
    .modal-content .modal-header button {
        left: 13px;
        right: unset;
        top: 6px;
    }
    .close {
        font-size: 31px !important;
    }
    .modal .modal-header .close {
        color: #fff;
    }
    .btn-div {
        text-align: center;
    }

    .div-logo-item {
        border-bottom: 1px solid #ddd;
        padding: 25px 5px 25px 10px;
    }

    .btn-div {
        margin-top: 15px;
    }

    .price-all {
        padding: 10px 0 10px 0;
        text-align: center;
    }

    .btn-reject {
        background-color: #e36e6e !important;
    }

    .btn-save {
        background-color: #59b959 !important;
    }

    .btn-main {
        text-align: center;
    }
</style>